// extracted by mini-css-extract-plugin
export var breadcrumbs = "glossary-content-module--breadcrumbs--JdyIl";
export var descriptionContainer = "glossary-content-module--description-container--Qh-2D";
export var glossaryContainer = "glossary-content-module--glossary-container--YTLlq";
export var header = "glossary-content-module--header--dpqdE";
export var img = "glossary-content-module--img--nS32m";
export var imgContainer = "glossary-content-module--img-container--wnj3n";
export var innerWrapper = "glossary-content-module--inner-wrapper--M9fsY";
export var outerWrapper = "glossary-content-module--outer-wrapper--mQofh";
export var postsContainer = "glossary-content-module--posts-container--fQ2JM";
export var readMoreSection = "glossary-content-module--read-more-section--ZzyOD";
export var searchFilters = "glossary-content-module--search-filters--HNS5i";
export var slideContainer = "glossary-content-module--slide-container--D9w52";
export var termsListContainer = "glossary-content-module--terms-list-container--0sLQt";